import { DocShapeId } from '@/utils/shapeIds';
import { ICartState } from '@/ui/store/cart/types';
import { Subscription } from '@/ui/services/SubscriptionService';
import { DigitalProduct } from '@/ui/services/DigitalProductService';
import { Smartlock } from '@/ui/services/SmartlockService';
import { Accessory } from '@/ui/services/AccessoryService';
import {
  SubscriptionProductDetailsFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { SmartlockCrystallizeData } from '@/ui/components/pages/ProductDetail/SmartlockDetail/types/SmartlockCrystallizeData';
import { AccessoryCrystallizeData } from '@/ui/components/pages/ProductDetail/AccessoryDetail/types/AccessoryCrystallizeData';

export type InstantiatedProduct = Subscription | DigitalProduct | Smartlock | Accessory;

export const instantiateProductFromShape = (
  shapeId: string,
  contentData: unknown,
  cartStore: ICartState,
): InstantiatedProduct | null => {
  if (shapeId === DocShapeId.subscription) {
    return new Subscription(contentData as SubscriptionProductDetailsFragment, cartStore);
  }
  if (shapeId === DocShapeId.digitalProduct) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new DigitalProduct(contentData as any, cartStore);
  }
  if (shapeId === DocShapeId.smartLock) {
    return new Smartlock(contentData as SmartlockCrystallizeData, cartStore);
  }
  if (shapeId === DocShapeId.accessory) {
    return new Accessory(contentData as AccessoryCrystallizeData, cartStore);
  }
  return null;
};
